import edit_button from '../edit_button.html';

export default function (nga, admin) {
    var channelstreamsourceClone = admin.getEntity('ChannelStreamSourcesClone');
    channelstreamsourceClone.creationView()
        .title('<h4>Channel Stream Sources <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Channel Stream Source</h4>')
        .fields([
            nga.field('stream_source', 'string')
                .attributes({ placeholder: 'Stream Source' })
                .validation({ required: true })
                .label('Stream Source Name'),
            nga.field('base_ip_address', 'string')
                .attributes({ placeholder: 'Ex: 10.10.xxx.x' })
                .label('Base IP Address'),
            nga.field('media_root_path', 'string')
                .attributes({ placeholder: 'Ex: /var/www/media/' })
                .label('Forensic Watermark Path'),
            nga.field('startup_channel', 'reference')
                .targetEntity(admin.getEntity('Channels'))
                .targetField(nga.field('title'))
                .isDetailLink(false)
                .label('Startup Channel'),
            nga.field('template')
                .label('')
                .template(edit_button)
        ]);

    channelstreamsourceClone.editionView()
        .title('<h4>Channel Stream Sources <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.stream_source }}</h4>')
        .actions(['list'])
        .fields([
            channelstreamsourceClone.creationView().fields()
        ]);
    return channelstreamsourceClone;
}


// WEBPACK FOOTER //
// ./js/channelStreamSourceClone/config.js